export default (state = {}, { payload, type }) => {
  switch (type) {
    default:
      if (payload.entities && payload.entities.terms)
        return { ...state, ...payload.entities.terms }

      return state
  }
}
